import { fonts } from "../consts";
import {
  FontPlusSVG,
  FontMinusSVG,
  ColorPalleteSVG,
  BoldSVG,
  ItalicSVG,
} from "./SVG.jsx";

const TextOptionsMenu = ({
  font,
  color,
  fontSize,
  isBold,
  isItalic,
  onStyleChange,
}) => {
  return (
    <div className="p-2 z-50">
      <div className="flex items-center space-x-4">
        <div className="flex items-center">
          <select
            value={font}
            onChange={(e) => onStyleChange({ font: e.target.value })}
            className="appearance-none bg-transparent border-none p-1 cursor-pointer hover:bg-gray-100 rounded"
            title="Change font"
          >
            {fonts.map((font) => (
              <option key={font.value} value={font.value}>
                {font.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex items-center space-x-2">
          <button
            onClick={() =>
              onStyleChange({ fontSize: Math.max(10, fontSize - 2) })
            }
            className="p-1 hover:bg-gray-100 rounded"
            title="Decrease font size"
          >
            <FontMinusSVG className="w-5 h-5" />
          </button>
          <button
            onClick={() => onStyleChange({ fontSize: fontSize + 2 })}
            className="p-1 hover:bg-gray-100 rounded"
            title="Increase font size"
          >
            <FontPlusSVG className="w-5 h-5" />
          </button>
        </div>

        <div className="flex items-center">
          <input
            type="color"
            value={color}
            onChange={(e) => onStyleChange({ color: e.target.value })}
            className="sr-only"
            id="colorPicker"
          />
          <label
            htmlFor="colorPicker"
            className="p-1 cursor-pointer hover:bg-gray-100 rounded"
            title="Change color"
          >
            <ColorPalleteSVG className="w-5 h-5" />
          </label>
        </div>

        <div className="flex items-center space-x-2">
          <button
            onClick={() => onStyleChange({ isBold: !isBold })}
            className={`p-1 hover:bg-gray-100 rounded ${
              isBold ? "bg-gray-200" : ""
            }`}
            title="Bold"
          >
            <BoldSVG />
          </button>
          <button
            onClick={() => onStyleChange({ isItalic: !isItalic })}
            className={`p-1 hover:bg-gray-100 rounded ${
              isItalic ? "bg-gray-200" : ""
            }`}
            title="Italic"
          >
            <ItalicSVG />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TextOptionsMenu;
